module.exports = __webpack_public_path__ + "img/violet_120.bf55f12f.png";